import { GetQuestionnaireResponse } from "api/models";
import { apiClient } from "../utils";

export const getQuestionnaire = async (shopId: number) => {
  const { data } = await apiClient.get<GetQuestionnaireResponse>(`questionnaire/${shopId}`);

  return data;
};
